// Color conversions:
// #01dbc2 = rgb(1, 219, 194)
// #FF686D = rgb(255, 104, 109)
// See vars.scss for more colors
export const SColors = {
  indicatorGreenGradientStart: '#30dd59',
  indicatorGreenGradientEnd: '#1b7e32',
  indicatorGreenGradientSteps: ['#30dd59', '#2bc44f', '#25ac45', '#20943b', '#1b7e32'],
  indicatorRedGradientStart: '#ff9f64',
  indicatorRedGradientEnd: '#e00911',
  indicatorRedGradientSteps: ['#ff9f64', '#f9844f', '#f2673a', '#ea4526', '#e00911'],
  indicatorGray: '#f0efed',
  lightCyan: 'rgba(1, 219, 194, 0.12)',
  cyan: '#01dbc2',
  gray: '#8e8c86',
  mediumGray: '#a0a0a0',
  mediumLightGray: 'rgba(160, 160, 160, 0.12)',
  grayBgHover: '#E0DFDA',
  grayBodyBackground: '#f9f8f6',
  grayBackground: '#f3f2ee',
  green: '#2aa948',
  mainTextColor: '#001549',
  redBad: '#FF686D',
  wheelRed: '#FF686D',
  lightRedBad: 'rgba(255, 104, 109, 0.12)',
  wheelGreen: '#2aa948',
  yellow: '#B2901C',
  yellowLight: '#FFF9E0',
  blue: '#285CFF',
  blueLight: '#E0E8FF',
  statsBlue: '#153aa8',
  statsBlueLight: 'rgba(21, 58, 168, 0.12)',

  // PDCA colors
  // Must be the same as the colors in vars.scss
  // WARNING: used in schedule.vue and schedule-event.vue
  pdcaPlan: '#EA444D',
  pdcaPlanMedium: '#FFE4E4',
  pdcaPlanMediumHover: '#EA444D33',
  pdcaPlanBg: '#FFF6F6',
  pdcaPlanHover: '#FFEFEF',
  pdcaDo: '#285CFF',
  pdcaDoMedium: '#E0E8FF',
  pdcaDoMediumHover: '#285CFF33',
  pdcaDoBg: '#F8F9FF',
  pdcaDoHover: '#F0F4FF',
  pdcaCheck: '#9B7800',
  pdcaCheckMedium: '#FFECAB',
  pdcaCheckMediumHover: '#B2901C33',
  pdcaCheckBg: '#FFFAE8',
  pdcaCheckHover: '#FFF8E0',
  pdcaAct: '#46b460',
  pdcaActMedium: '#d1f0e5',
  pdcaActMediumHover: '#ccebd7',
  pdcaActBg: '#f4fcfb',
  pdcaActHover: '#eefaf6',
  pdcaPending: '#999999',
  pdcaPendingMedium: '#E0DFDA',
  pdcaPendingMediumHover: '#ccebd7',
  pdcaPendingBg: '#f9f8f6',
  pdcaPendingHover: '#f3f2ee',

  // green: '#00BEA8',
  // WARNING: colors below haven't been updated after the design udpate
  darkRedBad: '#C00F15',
  mgtCompactRedBad: '#B71528',
  orange: '#CD5E1E',
};

SColors.indicatorsGreenLine = SColors.green;
SColors.indicatorsRedLine = SColors.redBad;
SColors.indicatorsGreenBg = SColors.lightCyan;
SColors.indicatorsRedBg = SColors.lightRedBad;


export const RGBColors = {
  indicatorGreenGradientStart: { r: 48, g: 221, b: 89 },
  indicatorGreenGradientEnd: { r: 27, g: 126, b: 50 },
  indicatorRedGradientStart: { r: 255, g: 159, b: 100 },
  indicatorRedGradientEnd: { r: 224, g: 9, b: 17 },
  gray: { r: 136, g: 136, b: 136 },
  green: { r: 27, g: 126, b: 50 },
  blue: { r: 30, g: 64, b: 236 },
  red: { r: 224, g: 9, b: 17 },
  orange: { r: 205, g: 94, b: 30 },
  yellow: { r: 242, g: 195, b: 11 },
  gwStatGray: { r: 145, g: 145, b: 145, a: 0.68 },
  gwStatGreen: { r: 4, g: 142, b: 43, a: 0.68 },
  gwStatRed: { r: 236, g: 28, b: 36, a: 0.68 },
};

export const PB_STATE_COLORS = [
  SColors.gray,
  SColors.gray,
  SColors.yellow,
  SColors.blue,
  SColors.green,
];

export const TIME_RANGE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const WHEEL_RANGE_FORMAT = 'YYYY-MM';
export const GWO_DATE_STORAGE_KEYNAME = 'gwOverlayLastDate';

// Stats related constants
export const STAT_CHART_TYPES = [
  { type: 'line', i18nLabel: 'message.LINE' },
  { type: 'bar', i18nLabel: 'message.BARS' },
];

// Id of each items in STAT_CATEGORIES
export const STAT_CATEGORIES_PROBLEMS = 0;
export const STAT_CATEGORIES_ACTIONS = 1;
export const STAT_CATEGORIES_MEETINGS = 2;
export const STAT_CATEGORIES = [
  { i18nLabel: 'message.PROBLEMS', id: STAT_CATEGORIES_PROBLEMS },
  { i18nLabel: 'message.ACTIONS', id: STAT_CATEGORIES_ACTIONS },
  { i18nLabel: 'message.MEETINGS', id: STAT_CATEGORIES_MEETINGS },
];

export const STAT_TYPES = [
  {
    key: 'createdProblems',
    category: 0, // See STAT_CATEGORIES
    chartType: 'line', // See STAT_CHART_TYPES
    i18nLabel: 'message.REPORTED_PB_NUMBER',
  },
  {
    key: 'ongoingProblems',
    category: 0,
    chartType: 'line',
    i18nLabel: 'message.ONGOING_PB_NUMBER',
  },
  {
    key: 'completedProblems',
    category: 0,
    chartType: 'line',
    i18nLabel: 'message.COMPLETED_PB_NUMBER',
  },
  {
    key: 'createdGWProblems',
    category: 0,
    chartType: 'line',
    i18nLabel: 'message.REPORTED_GW_PB_NUMBER',
  },
  {
    key: 'createdActions',
    category: 1,
    chartType: 'line',
    i18nLabel: 'message.REPORTED_ACTIONS_NUMBER',
  },
  {
    key: 'ongoingActions',
    category: 1,
    chartType: 'line',
    i18nLabel: 'message.ONGOING_ACTIONS_NUMBER',
  },
  {
    key: 'completedActions',
    category: 1,
    chartType: 'line',
    i18nLabel: 'message.COMPLETED_ACTIONS_NUMBER',
  },
  {
    key: 'actionsPostponements',
    category: 1,
    chartType: 'line',
    i18nLabel: 'message.ACTIONS_POSTPONED',
  },
  {
    key: 'createdGWActions',
    category: 1,
    chartType: 'line',
    i18nLabel: 'message.REPORTED_GW_ACTIONS_NUMBER',
  },
  {
    key: 'pbTypes',
    category: 0,
    chartType: 'bar',
    i18nLabel: 'message.PROBLEM_DISTRIBUTION_TYPE',
  },
  {
    key: 'pbIndics',
    category: 0,
    chartType: 'bar',
    i18nLabel: 'message.PROBLEM_DISTRIBUTION_INDICS',
  },
  {
    key: 'pbRecurrence',
    category: 0,
    chartType: 'bar',
    i18nLabel: 'message.PROBLEM_RECURRENCE_BREAKDOWN',
  },
  {
    key: 'ratings',
    category: 2,
    chartType: 'bar',
    i18nLabel: 'message.MEETING_RATING_DISTRIBUTION',
  },
];

export const MEETING_RATING_SCALE = [
  { i18nLabel: 'message.NO_RATING' },
  { i18nLabel: 'message.UNACCEPTABLE' },
  { i18nLabel: 'message.BAD' },
  { i18nLabel: 'message.ACCEPTABLE' },
  { i18nLabel: 'message.GOOD' },
];

export const DEFAULT_5W1H_HINTS = [
  { trad: 'WHO', key: 'lWho', help: 'sensei.W5H1_WHO_EXAMPLES' },
  { trad: 'WHAT', key: 'lWhat', help: 'sensei.W5H1_WHAT_EXAMPLES' },
  { trad: 'WHERE', key: 'lWhere', help: 'sensei.W5H1_WHERE_EXAMPLES' },
  { trad: 'WHEN', key: 'lWhen', help: 'sensei.W5H1_WHEN_EXAMPLES' },
  { trad: 'HOW', key: 'lHow', help: 'sensei.W5H1_HOW_EXAMPLES' },
  { trad: 'HOW_MUCH', key: 'lHowMuch', help: 'sensei.W5H1_HOWMUCH_EXAMPLES' },
  { trad: 'WHY', key: 'lWhy', help: 'sensei.W5H1_WHY_EXAMPLES' },
];

// Local storage keys
export const LSK_LOGIN_MODE = 'LSK_LOGIN_MODE';
export const LSK_SSO_LOGIN_MODE = 'LSK_SSO_LOGIN_MODE';
export const LSK_SSO_LOGIN_USER = 'LSK_SSO_LOGIN_USER';
export const LSK_SSO_LOGIN_TEAM = 'LSK_SSO_LOGIN_TEAM';
export const LSK_HIDE_ALL_RELEASE_ESSENTIAL = 'LSK_HIDE_ALL_RELEASE_ESSENTIAL';
export const LSK_HIDE_NEWEST_RELEASE_ESSENTIAL = 'LSK_HIDE_NEWEST_RELEASE_ESSENTIAL';
export const LSK_HIDE_VH_CRITERION_SENSEI = 'LSK_HIDE_VH_CRITERION_SENSEI';
export const LSK_HIDE_VH_WELCOME = 'LSK_HIDE_VH_WELCOME';
export const LSK_HIDE_VH_HIDE_HELP_BANNER = 'LSK_HIDE_VH_HIDE_HELP_BANNER';
export const LSK_HIDE_PAGE_HELP = 'LSK_HIDE_PAGE_HELP';
export const LSK_HIDE_INDICATORS_PB_REPORT_HINT = 'LSK_HIDE_INDICATORS_PB_REPORT_HINT';
export const LSK_DATA_USAGE_DISPLAYED = 'LSK_DATA_USAGE_DISPLAYED';
export const LSK_NEW_DESIGN_VIDEO_WATCHED = 'LSK_NEW_DESIGN_VIDEO_WATCHED';

// Constant delays in ms
export const DELAY_LOGIN_ATTEMPT = 2000;

// User Roles
export const ROLE_SUPER_ADMIN = 1;
export const ROLE_ADMIN = 2;
export const ROLE_SETTINGS = 3;
export const ROLE_PROBLEMS = 4;

/**
 * Values object is formatted as { <date>: <valueObject>, <date2>: <value2Object>, ...}
 * This is the date format of the key
 */
export const valueKeyFormat = 'YYYY-MM-DD';


export default {
  SColors,
  TIME_RANGE_FORMAT,
  WHEEL_RANGE_FORMAT,
  GWO_DATE_STORAGE_KEYNAME,
  STAT_CHART_TYPES,
  STAT_CATEGORIES,
  STAT_TYPES,
  MEETING_RATING_SCALE,
  DEFAULT_5W1H_HINTS,

  LSK_LOGIN_MODE,
  LSK_SSO_LOGIN_MODE,
  LSK_SSO_LOGIN_USER,
  LSK_SSO_LOGIN_TEAM,
  LSK_HIDE_ALL_RELEASE_ESSENTIAL,
  LSK_HIDE_NEWEST_RELEASE_ESSENTIAL,
  LSK_HIDE_VH_CRITERION_SENSEI,
  LSK_HIDE_VH_WELCOME,
  LSK_HIDE_VH_HIDE_HELP_BANNER,
  LSK_HIDE_PAGE_HELP,
  LSK_HIDE_INDICATORS_PB_REPORT_HINT,
  LSK_DATA_USAGE_DISPLAYED,
  LSK_NEW_DESIGN_VIDEO_WATCHED,

  DELAY_LOGIN_ATTEMPT,

  ROLE_SUPER_ADMIN,
  ROLE_ADMIN,
  ROLE_SETTINGS,
  ROLE_PROBLEMS,

  valueKeyFormat,
};
